<template>
    <div class="list-item" @mouseover="mouseover(index)" @mouseleave="mouseover(false)">
      <div :class="['item', (item.link ? 'link' : '')]" @click="click(item)">
        <img class="img" v-if="item.photo" :src="item.photo">
        <div class="img-hover" :style="{ backgroundImage: item.image_hover ? 'url(' + item.image_hover + ')' : 'none' }" ></div>
      </div> 
    </div>
</template>

<script>

export default {
  props: [
    'item',
    'index'
  ],

  methods: {
    click (item) {
      if (item.link) {
        window.open(item.link, '_blank');
      }
    },

    mouseover (index) {
      this.$emit('mouseover', index)
    }
  }
}
</script>

<style lang="scss">
.partners {
  .list-item {
    width: 50%;
    padding: 3px;

    .title {
      transition: all 0.3s ease;
      flex-direction: column;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.3);
      height: 100%;
      cursor: pointer;
      .text {
        width: 80%;
        margin-left: -80px;
        font-family: Montserrat;
        font-size: 20px;
        text-align: left;
        @media screen and (max-width: 1300px) {
          font-size: 12px;
          margin-left: -50px;
        }
  
        @media screen and (max-width: 768px) {
          font-size: 22px;
        }

        @media screen and (max-width: 360px) {
          font-size: 17px;
        }
      }
      &:hover {
        background-color: rgba(0, 0, 0, 0.55);
      }
    }
    .item {
      width: 100%;
      position: relative;
      transition: all 0.3s ease;
      padding: 10px; 
      @media screen and (max-width: 768px) {
        height: 270px;
      }
      &.link {
        cursor: pointer;
      }

      img {
        width: 100%;
      }

      .img-hover {
        position: absolute;
        left: 10px;
        right: 10px;
        bottom: 10px;
        top: 10px;
        opacity: 0;
        transition: opacity .5s ease;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
      }
      @media screen and (min-width: 768px) {
        &:hover {
          background-color: white;
          border-radius: 5px;
          .img-hover {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>